import styled from 'styled-components';
import MuiDrawer from "@material-ui/core/Drawer";

export const StyledMuiDrawer = styled(MuiDrawer)``;
